"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("./hooks");
function Mask(_a) {
  var visible = _a.visible,
    className = _a.className,
    _b = _a.style,
    style = _b === void 0 ? {} : _b,
    onClose = _a.onClose,
    children = _a.children;
  var target = hooks_1.usePortal('invertase-ui-portal');
  hooks_1.useLockBodyScroll(visible);
  var mask = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    tabIndex: -10,
    role: "button",
    onClick: onClose,
    onKeyPress: onClose,
    className: classnames_1.default('transition transition-opacity duration-300 fixed inset-0 z-40', className, {
      'opacity-100 pointer-events-auto': visible,
      'opacity-0 pointer-events-none': !visible
    }),
    style: __assign({
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }, style)
  }), visible && children);
  // SSR
  if (!target) {
    return null;
  }
  return react_dom_1.createPortal(mask, target);
}
exports.Mask = Mask;